export function awardsSlider() {
    $(window).on("load resize", function () {
        $(".awards-list").each(function () {
            let $this = $(this);
            let awardsLength = $this.find(".item").length;
            if (window.innerWidth >= 1024 && awardsLength > 7 && !$this.hasClass("active")) {
                $this.addClass("active");
                $this.infiniteslide({
                    direction: "left",
                    speed: 30,
                    pauseonhover: false
                });
            } else {
                $this.removeAttr("data-style style").find(".item").removeAttr("style");
                let parentsSlider = $this.parents(".infiniteslide_wrap");
                $this.removeClass("active").find(".infiniteslide_clone").remove();
                let clone = $this.clone();
                parentsSlider.before(clone);
                parentsSlider.remove();
            }
        });
    });
}



// WEBPACK FOOTER //
// ./assets/js/modules/awardsSlider.js